module.exports = __webpack_public_path__ + "img/navbar-bg@3x.53c4e930.png";